module.exports = __webpack_public_path__ + "static/img/Peter_Wright_desktop.7aa7115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Peter_Wright_desktop.jpg
// module id = 6Rxp
// module chunks = 0